import { Link, useLocation, useNavigate } from "react-router-dom";
import Image from "../../../../../components/elements/Image";
import Input from "../../../../../components/form/Input";
import Button from "../../../../../components/form/Button";
import EventBG from "../../../../../assets/images/event-list.webp";
import Form from "../../../../../components/form/Form";
import useForm from "../../../../../hooks/useForm";
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { authSignup } from "../../../../../services/authService";
import Select from "../../../../../components/form/select/Select";
import { t } from "i18next";

const signUpValidation = {
  email: [
    {
      type: "email",
      required: true,
      message: "Enter valid Email",
    },
  ],
  password: [
    {
      type: "password",
      minLength: 8,
      required: true,
      message:
        "Password must be strong (min 8 characters, including uppercase, lowercase, number, and symbol)",
    },
  ],
  confirmPassword: { required: true, message: "Confirm Password is Required" },
  firstName: { required: true, message: "Please Enter the Name" },
};

const Register = () => {
  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    setFieldsValue,
    formValidate,
  } = useForm({
    validationRules: signUpValidation,
    initialState: { role: "user" },
  });
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location?.search);
  const { callback } = Object.fromEntries(params.entries());

  const { mutate: onSubmit, isPending: isLoading } = useMutation({
    mutationFn: async (val) => {
      const payload = {
        ...val,
      };
      return await authSignup(payload);
    },
    onSuccess: (res) => {
      if (res?.status === 200 || res?.status === 201) {
        toast.success(res?.message);
        navigate(
          `/account-verification${callback ? "?callback=" + callback : ""}`,
          {
            state: { email: res?.data?.email },
          }
        );
        return res;
      } else {
        toast.warning(res?.message || res?.error);
      }
      return res;
    },
    onError: (error) => {
      console.log(error);
    },
  });

  return (
    <div className="flex items-center justify-center bg-gradient-to-br from-[#F9F6FF] to-[#F4F1FD] p-6 relative">
      <div className="p-2 border-2 border-white rounded-4xl max-w-6xl w-full">
        <div className="grid grid-cols-12  bg-white rounded-4xl">
          <div className="col-span-6 py-14 px-20 flex flex-col justify-center">
            <Link
              to="/"
              className="w-48 overflow-hidden aspect-[7/1] block mb-5"
            >
              <Image
                src={require("../../../../../assets/images/logo.png")}
                classes={"object-contain"}
              />
            </Link>
            <h1 className="text-2xl font-bold text-deep-purple mb-1">
              {t("Welcome! Register your account")}
            </h1>
            <div className="text-slate-500 mb-5">
              {t("Fill the below form to Register")}
            </div>
            <Form
              onSubmit={onSubmit}
              handleSubmit={handleSubmit}
              className="space-y-6"
            >
              <div className="relative">
                <Input
                  label={t("name")}
                  labelClasses="!text-base capitalize"
                  inputType="text"
                  inputClasses={"h-14 focus:!border-primary"}
                  inputName={"firstName"}
                  value={values?.firstName || ""}
                  onChange={handleChange}
                  {...formValidate(errors, "firstName")}
                />
              </div>
              <div className="relative">
                <Input
                  label={t("email")}
                  labelClasses="!text-base !capitalize"
                  inputType="email"
                  inputClasses={"h-14 focus:!border-primary"}
                  inputName={"email"}
                  value={values?.email || ""}
                  onChange={handleChange}
                  {...formValidate(errors, "email")}
                />
              </div>
              <div className="relative">
                <Input
                  label={t("password")}
                  labelClasses="!text-base capitalize"
                  inputType="password"
                  inputClasses={"h-14 focus:!border-primary"}
                  inputName={"password"}
                  value={values?.password || ""}
                  onChange={handleChange}
                  {...formValidate(errors, "password")}
                />
              </div>
              <div className="relative">
                <Input
                  label={t("confirm password")}
                  labelClasses="!text-base capitalize"
                  inputType="password"
                  inputClasses={"h-14 focus:!border-primary"}
                  inputName={"confirmPassword"}
                  value={values?.confirmPassword || ""}
                  onChange={handleChange}
                  {...formValidate(errors, "confirmPassword")}
                />
              </div>
              <div className="relative">
                <Select
                  label={`${t("I want to")}...`}
                  labelClasses="!text-base capitalize"
                  dropdownButtonClass={"rounded-md !h-14"}
                  onChange={(val) =>
                    handleChange({ target: { name: "role", value: val } })
                  }
                  selectedValue={values?.role}
                  dropdownData={[
                    { value: "user", name: "Book events" },
                    { value: "organization", name: "Host events" },
                  ]}
                  placements={"top-start"}
                />
              </div>
              <div className="relative">
                <Button
                  buttonType="submit"
                  buttonIconPosition={"left"}
                  buttonIcon={"fa-regular fa-arrow-right"}
                  buttonLabel={t("register")}
                  buttonLabelClasses="capitalize"
                  {...(isLoading && {
                    loading: true,
                    buttonIconPosition: "left",
                    isDisable: true,
                  })}
                />
              </div>
            </Form>
          </div>
          <div className="col-span-6 pt-5 pr-5 pb-5 pl-0">
            <div className="space-y-5 rounded-2xl overflow-hidden bg-gradient-to-br from-[#F9F6FF] to-[#F4F1FD] py-14 pl-10 flex flex-col w-full">
              <div className="capitalize text-slate-500 text-xs bg-white border border-text-disabled rounded-md p-1 max-w-60 text-center flex items-center justify-center">
                {t("dancebrite system pressure control")}
              </div>
              <div className="text-slate-500 font-medium text-base max-w-96 w-full">
                {t("Manage your concreting and construction operation")}{" "}
                <span className="text-deep-purple0">
                  {t("more professionally")}
                </span>
              </div>
              <div className="w-full aspect-[5/4] overflow-hidden">
                <Image src={EventBG} classes={"object-cover"} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-decoration bg-decoration-1"></div>
      <div className="bg-decoration bg-decoration-2"></div>
      <div className="bg-decoration bg-decoration-3"></div>
    </div>
  );
};

export default Register;
